import { createApp } from 'vue'
import FeedbackWidget from './components/embedded_feedback_widget'

class SophiaFeedback extends HTMLElement {
  connectedCallback() {
    const props = {
      type: this.getAttribute('type').toLowerCase().replace(/\s+/g, '_'),
      cta: this.getAttribute('cta') || 'Submit',
      question: this.getAttribute('question') || 'We want to provide you with the best possible experience. Do you find it useful?',
      placeholder: this.getAttribute('placeholder') || 'What would make it better?',
      color: (this.getAttribute('color') || 'blue').toLowerCase(),
      extras: {},
      dataId: this.getAttribute('data-id')
    }

    for (const attr of this.attributes) {
      if (attr.name.startsWith('extra-')) {
        const key = attr.name.replace('extra-', '')
        props.extras[key] = attr.value
      }
    }
    if (!props.type) return

    // if already submitted
    if (localStorage.getItem(`feedback-submitted-${props.dataId}`)) return

    const mountPoint = document.createElement('div')
    this.appendChild(mountPoint)

    const app = createApp(FeedbackWidget, props)
    app.mount(mountPoint)
  }
}

customElements.define('sophia-feedback', SophiaFeedback)
